import React, { memo } from 'react'
import { faHourglass } from '@fortawesome/pro-duotone-svg-icons'

import Popup from '../../shared/popup/Popup'
import {
  transactionDescLabel,
  transactionTitleLabel
} from '../../../util/transactionRow.helpers'

const FuturePointsInfo = ({ isNft, onSubmit, t }) => {
  return (
    <Popup
      submitLabel={t('common.close')}
      onFormSubmit={onSubmit}
      title={t(transactionTitleLabel(isNft))}
      description={t(transactionDescLabel(isNft))}
      icon={faHourglass}
    />
  )
}

export default memo(FuturePointsInfo)
